import _ from 'lodash';

const updateInputMultipleChoice = ({ choice, _prevInput }) => {
  return {
    v: 1,
    s: choice.uuid,
  };
};

const updateInputSelectMultiple = ({ choice, prevInput }) => {
  const prevS = prevInput.s || [];

  const s = _.includes(prevS, choice.uuid)
    ? _.without(prevS, choice.uuid)
    : prevS.concat(choice.uuid);

  return {
    v: 1,
    s,
  };
};

const updateInputClozeDeletion = ({ choice, prevInput, evaluated }) => {
  const { choices } = evaluated;
  const prevS = prevInput.s || [];

  const s = (() => {
    if (_.includes(prevS, choice.uuid)) {
      return _.without(prevS, choice.uuid);
    }

    const choiceGroup = _.find(choices, (choiceSet) => {
      const choiceSetUuids = choiceSet.map((choiceSetChoice) => choiceSetChoice.uuid);
      return _.includes(choiceSetUuids, choice.uuid);
    });

    const choiceGroupUuids = choiceGroup.map((x) => x.uuid);
    const nextS = _.without(prevS, ...choiceGroupUuids);
    nextS.push(choice.uuid);

    return nextS;
  })();

  return {
    v: 1,
    s,
  };
};

const updateInputQuantityComparison = ({ choice, _prevInput }) => {
  return {
    v: 1,
    s: choice.uuid,
  };
};

const updateInputNumeric = ({ choice, _prevInput }) => {
  return {
    v: 1,
    s: choice,
  };
};

const UPDATE_INPUT_ITEM_TYPE_MAP = {
  actEnglishMultipleChoice: updateInputMultipleChoice,
  clozeDeletion: updateInputClozeDeletion,
  multipleChoice: updateInputMultipleChoice,
  numeric: updateInputNumeric,
  passageChooseMany: updateInputSelectMultiple,
  passageChooseOne: updateInputMultipleChoice,
  passageChooseSentence: updateInputMultipleChoice,
  quantityComparison: updateInputQuantityComparison,
  selectMultiple: updateInputSelectMultiple,
  sentenceEquivalence: updateInputSelectMultiple,
};

export const updateInput = ({ choice, prevInput, evaluated, itemType }) => {
  const updateInputFn = UPDATE_INPUT_ITEM_TYPE_MAP[itemType];
  const nextInput = updateInputFn({ choice, prevInput, evaluated });
  return nextInput;
};
